import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SummarySectionsList from './SummarySectionsList';
import { CloseButton, CloseButtonRollover } from '../../shared/svg/components';
import SaveConfigurationService from '../../services/SaveConfigurationService';
import DownloadPdfService from '../../services/DownloadPdfService';
import {
  changeIsSummaryOpened,
  downloadPdf,
  initializeSections,
  initializeSummaryCameras,
  saveConfiguration,
  setSnackbarMessage,
} from '../../model/configuratorSlice';
import { SnackbarMessages } from '../../model/constants';

const SummaryPanel = () => {
  const {
   settings, isSummaryOpened, userLoggedIn, summaryShots, legalSettings,
  } = useSelector(state => state.configurator);
  const [topShot, setTopShot] = useState(null);
  const [bottomShot, setBottomShot] = useState(null);

  const saveConfigurationMutation = SaveConfigurationService();
  const downloadPdfMutation = DownloadPdfService();
  const dispatch = useDispatch();

  useEffect(() => {

  }, [summaryShots]);

  useEffect(() => {
    dispatch(initializeSummaryCameras());
    dispatch(initializeSections());

    if (summaryShots != null && summaryShots.length === 2) {
      setTopShot(summaryShots[0]);
      setBottomShot(summaryShots[1]);
    }
  }, [isSummaryOpened]);

  useEffect(() => {

  }, [summaryShots]);

  return (
    <div className={`summary-panel ${isSummaryOpened ? 'opened' : ''}`}>
      <div className="summary-content">
        <div className="left-container">
          <div className="top-image">
            {topShot !== null && (
              <img src={`${settings.shots_base_url}/${topShot}.jpg`} alt="" />
            )}
          </div>
          <div className="bottom-image">
            {bottomShot !== null && (
              <img src={`${settings.shots_base_url}/${bottomShot}.jpg`} alt="" />
            )}
          </div>
        </div>
        <div className="right-container">
          <button
            className="close-button"
            type="button"
            onClick={() => dispatch(changeIsSummaryOpened(false))}
          ><CloseButton className="close-default" /><CloseButtonRollover className="close-over" />
          </button>
          <div className="container-summary-section-list-legal-text">
            <SummarySectionsList />
            <div className="legal-text">{legalSettings.legalNote}</div>
          </div>
          <div className={`summary-buttons-container${userLoggedIn ? ' logged-in' : ''}`}>
            {/* userLoggedIn ? (
              <button
                className="request-budget-button"
                type="button"
                disabled
                onClick={() => dispatch(changeIsRequestBudgetOpened(true))}
              >Formalizar
              </button>
            ) : null */}
            {/* <button
              className="save-button"
              type="button"
              disabled
              onClick={() => {
                if (userLoggedIn) {
                  dispatch(setSnackbarMessage(SnackbarMessages.DisabledInDemo));
                } else {
                  saveConfigurationMutation.mutate();
                  dispatch(saveConfiguration());
                }
              }}
            >Guardar
            </button> */}
            <button
              className="download-button"
              type="button"
              onClick={() => {
                downloadPdfMutation.mutate();
                dispatch(downloadPdf());
              }}
            ><span>Descargar Resumen</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryPanel;
